import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetOnboardStudent, onboardStudent } from "./onboard-student";

const initialState: ProcessingState = { processing: "idle" };

export const onboardStudentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(onboardStudent.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(onboardStudent.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(onboardStudent.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetOnboardStudent, () => {
    return initialState;
  });
});
